export default __webpack_public_path__ + "static/media/G_Grass.c34a712f.jpg";